// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"403":"2ff051e2","670":"3ec54a13"}[chunkId] + ".chunk.js";
};